import { AppBar } from "@material-ui/core";
import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ReactComponent as LogoImage } from "assets/brainhealth-project-logo.svg";
import { StyledGrid } from "components/simple";
import IconTray from "./IconTray";
import Navigation from "./Navigation";
import { spacingDefaults } from "style/constants";

const pathsToHide = ["/login", "/coaching-sessions", "/forgot_password", "/reset"];

const Header: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const fullLocation = location.pathname + location.search;
  const [, setIconActive] = useState(true);
  const [, setNavActive] = useState(true);

  const handleHomeClick = (): void => {
    history.push("/");
  };

  if (pathsToHide.some(p => fullLocation.includes(p))) return null;

  return (
    <>
      <StyledGrid marginTop={"80px"} />
      <AppBar position="fixed">
        <StyledGrid
          container
          alignItems="center"
          flexWrap="nowrap"
          justifyContent="space-between"
          padding={`0 ${spacingDefaults.large}`}
          overflowX="auto"
        >
          <StyledGrid item paddingTop="5px" onClick={handleHomeClick}>
            <LogoImage height="40px" />
          </StyledGrid>
          <Navigation setActive={setNavActive} />
          <IconTray setActive={setIconActive} />
        </StyledGrid>
      </AppBar>
    </>
  );
};

export default Header;
